import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  FiPlusCircle,
  FiTrash2,
  FiMaximize2,
  FiMinimize2,
} from "react-icons/fi";

import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import Button from "@material-ui/core/Button";
import { Dialog, IconButton, Portal } from "@material-ui/core";

import { FlatBtn, Input, PrimaryBtn } from "../../../Theme";
import { saveNeighborhoods } from "../../../Store/Modules/Store/Actions";
import {
  Item,
  ContainerAddNeighborhood,
  List,
  Container,
  ContainerActions,
} from "./style";

export default function DeliveryByNeighborhood() {
  const dispatch = useDispatch();
  const [fullScreen, setFullScreen] = React.useState(false);

  const initialNeighborhoods = useSelector(
    (state) => state.store.neighborhoodsPrice
  );

  const [neighborhoods, setNeighborhoods] =
    React.useState(initialNeighborhoods);

  function addNeighborhood() {
    setNeighborhoods([
      ...neighborhoods,
      { description: "", deliveryPrice: "" },
    ]);
  }

  const removeNeighborhood = (idx) => () => {
    setNeighborhoods(neighborhoods.filter((_, _idx) => _idx !== idx));
  };

  const removeAllNeighborhoods = () => {
    setNeighborhoods([]);
  };

  const handleChange = (idx) => (event) => {
    const list = [...neighborhoods];
    list[idx][event.target.name] = event.target.value;
    setNeighborhoods(list);
  };

  const handleCurrencyChange = (idx) => (event, value) => {
    const list = [...neighborhoods];
    list[idx][event.target.name] = value;
    setNeighborhoods(list);
  };

  const handleSave = () => {
    const bairrosOrdenados = sortNeighborhoods(neighborhoods);
    dispatch(saveNeighborhoods(bairrosOrdenados));
  };

  function handlePaste(event) {
    event.stopPropagation();
    event.preventDefault();

    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData("Text");

    const listParsed = [];
    pastedData.split("\r").forEach((value) => {
      const [description, price] = value.split("\t");
      if (!description.trim()) return;

      listParsed.push({
        description: description.trim(),
        deliveryPrice: price.replace(",", "."),
      });
    });

    const _ = neighborhoods.splice(0, neighborhoods.length - 1);
    setNeighborhoods([..._, ...listParsed]);
  }

  function sortNeighborhoods(neighborhoodsToSort) {
    const bairrosOrdenados = neighborhoodsToSort.sort((a, b) => {
      if (a.description.toLowerCase() > b.description.toLowerCase()) {
        return 1;
      }
      if (a.description.toLowerCase() < b.description.toLowerCase()) {
        return -1;
      }
      return 0;
    });

    return bairrosOrdenados;
  }

  const style = fullScreen
    ? {
        width: "100%",
        height: "100vh",
        zIndex: 999999,
        background: "white",
        top: 0,
        left: 0,
        bottom: 0,
        padding: "30px",
        position: "fixed",
      }
    : {};

  return (
    <>
      <Portal disablePortal={!fullScreen}>
        <Container style={{ ...style, transition: "all 2s" }}>
          
            <ContainerActions>
            {neighborhoods.length > 5 && (
              <Button
                variant="text"
                color="default"
                onClick={removeAllNeighborhoods}
                size="small"
                startIcon={
                  <FiTrash2 style={{ fontSize: "20px", color: "red" }} />
                }
              >
                Apagar lista
              </Button>
               )}
              {!fullScreen && (
                <IconButton
                  onClick={() => {
                    setFullScreen(true);
                  }}
                  title="Maximizar"
                >
                  <FiMaximize2 style={{ fontSize: "20px" }} />
                </IconButton>
              )}

              {fullScreen && (
                <IconButton
                  onClick={() => setFullScreen(false)}
                  title="Minimizar"
                >
                  <FiMinimize2 style={{ fontSize: "20px" }} />
                </IconButton>
              )}
            </ContainerActions>
         
          <List>
            {neighborhoods.map((neighborhood, idx) => (
              <Item key={idx}>
                <TextField
                  placeholder="Nome do bairro/local"
                  type="text"
                  name="description"
                  autoFocus={neighborhood.description === ""}
                  onChange={handleChange(idx)}
                  onPaste={handlePaste}
                  value={neighborhood.description}
                  label="Nome do Bairro"
                  variant="outlined"
                  size="small"
                  autoComplete="off"
                  style={{ width: "100%", marginRight: "10px" }}
                />
                <CurrencyTextField
                  onChange={handleCurrencyChange(idx)}
                  value={neighborhood.deliveryPrice}
                  label="Preço"
                  size="small"
                  name="deliveryPrice"
                  style={{ width: "140px" }}
                  variant="outlined"
                  placeholder="0"
                  currencySymbol="R$"
                  required
                  minimumValue="0"
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator="."
                />
                <FlatBtn onClick={removeNeighborhood(idx)}>
                  <FiTrash2 style={{ fontSize: "20px", color: "red" }} />
                </FlatBtn>
              </Item>
            ))}
          </List>

          <ContainerAddNeighborhood>
            <FlatBtn onClick={addNeighborhood}>
              <FiPlusCircle style={{ fontSize: "30px" }} />
            </FlatBtn>
          </ContainerAddNeighborhood>
          <hr />
          <Button variant="contained" color="primary" onClick={handleSave}>
            Salvar
          </Button>
        </Container>
      </Portal>
      {/* <Dialog open={false} fullScreen ref={containerRef}></Dialog> */}
    </>
  );
}
